<template>
  <div>
    <!-- <Bookingcards /> -->

    <router-view></router-view>
  </div>
</template>
<script>
// import Bookingcards from "./components/Bookingcards.vue";

export default {
  components: {
    // Bookingcards,
  },
};
</script>
